module.exports = __webpack_public_path__ + "img/idea-score-latest1.cbd778d4.svg";